import { ErrorWrapper, ResponseWrapper } from "@/core/service/util";
import { RoomBaseApiService } from "@/core/service/room.baseapi.service";

export class RoomGoalScheduleService extends RoomBaseApiService {

  async goalAndScheduleList() {
    try {
      const response = await this.request().get(
        `/api/v3/room/${this.getRoomId()}/goalAndScheduleList`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async changeScheduleState(data) {
    try {
      const response = await this.request().post(
        `/api/v3/room/${this.getRoomId()}/${data.scheduleId}/changeScheduleState`, data
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getLectureScheduleCallLayoutInfo(params) {
    try {
      const response = await this.request().get(
          `/api/v3/lecture/${this.getRoomId()}/schedule/${params.scheduleId}/layout`
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomGoalScheduleService = new RoomGoalScheduleService()